import { render, staticRenderFns } from "./LocationDetail.vue?vue&type=template&id=222e2350&"
import script from "./LocationDetail.vue?vue&type=script&lang=js&"
export * from "./LocationDetail.vue?vue&type=script&lang=js&"
import style0 from "./LocationDetail.vue?vue&type=style&index=0&id=222e2350&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports